import { hash } from '@ember/helper';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';
import { query } from 'umg-ember-backend/data/builders/umg-rest';

export default class RecordDetailFormsNewsletterComponent extends Component {
  // Services
  @service flashMessages;
  @service store;

  // Artist default newsletter target
  @tracked hasInitializedPrimaryTarget = false;

  get showNoConfigurationWarning() {
    return (
      this.args.loadLegalContext &&
      this.args.newsletterArtist &&
      !this.loadArtistTarget.isPending &&
      !this.loadArtistTarget.value
    );
  }

  loadArtistTarget = trackedFunction(this, async () => {
    const loadLegalContext = this.args.loadLegalContext;
    const newsletterArtist = this.args.newsletterArtist;

    if (!loadLegalContext || !newsletterArtist) {
      return;
    }

    try {
      const [legalContextId, primaryTarget] = await Promise.all([
        loadLegalContext.promise,
        this.args.model.primaryTarget,
      ]);

      const { content } = await this.store.request(
        query('newsletter-target', {
          'filter[target]': newsletterArtist.id,
          'filter[type]': 'artist',
          'filter[legalContext]': legalContextId,
          'limit': 1000,
        }),
      );

      const artistNewsletterTarget = content.data[0];

      if (
        artistNewsletterTarget &&
        !primaryTarget &&
        this.args.model.isNew &&
        !this.hasInitializedPrimaryTarget
      ) {
        this.args.model.primaryTarget = artistNewsletterTarget;
      }

      this.hasInitializedPrimaryTarget = true;

      return artistNewsletterTarget;
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });

  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      {{#if this.showNoConfigurationWarning}}
        <InfoBox @type='warning'>
          {{t 'record_detail.forms.newsletter.no_configuration'}}
        </InfoBox>
      {{/if}}
      <form.field
        @property='primaryTarget'
        @type='belongs-to'
        @disabled={{@loadLegalContext.isPending}}
        @filters={{hash legalContext=@loadLegalContext.value}}
        @on={{hash openNewRecord=false openRecord=false}}
      />

      <form.field
        @filters={{hash legalContext=@loadLegalContext.value dataSharing=false}}
        @disabled={{@loadLegalContext.isPending}}
        @property='additionalTargets'
        @type='has-many'
        @on={{hash openNewRecord=false openRecord=false}}
      />
    </Form>
  </template>
}
